import { useTranslation } from "react-i18next";
import { useState } from "react";

import apiClient from "../../lib/common/apiClient";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import ConfirmDialog from "../dialogTypes/ConfirmDialog";
import defineConf from "../../config/defineConf";

function TkPartnerPriceAgreementConfirmButton(props) {
    const { t } = useTranslation();

    const { id, schema, grid, refresh, makeItemName, onSuccess, onFailure, onPartialFailure, confirmType, ...others } =
        props;

    const [open, setOpen] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState();
    const [confirmData, setConfirmData] = useState();

    const makeReasonStr = (reasons) => {
        let reasonStr = " [";

        for (const index in reasons) {
            if (index > 0) {
                reasonStr += ", ";
            }

            reasonStr += reasons[index];
        }

        reasonStr += "]";

        return reasonStr;
    };

    const onOpen = () => {
        let confirmData = [];
        let confirmItemStr = "[";

        let firstRow = true;

        for (const item of grid.selectedItems) {
            if (!firstRow) {
                confirmItemStr += ", ";
            }

            if (makeItemName) {
                confirmItemStr += makeItemName(item);
            } else {
                let itemDetail = "{";

                let firstCol = true;

                for (let key of schema.keys) {
                    if (!firstCol) {
                        itemDetail += ", ";
                    }

                    itemDetail += t(`columnName.${key}`) + ": " + item[key];

                    firstCol = false;
                }

                itemDetail += "}";

                confirmItemStr += itemDetail;
            }

            firstRow = false;

            confirmData.push({ ...item });
        }

        confirmItemStr += "]";

        setConfirmMsg(
            t("dialog.msg.confirm.priceAgreementConfirm", {
                type: t(`tableName.${schema.name}`),
                instance: confirmItemStr,
            })
        );
        setConfirmData(confirmData);

        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onConfirmOk = (requestData) => {
        let url =
            confirmType === defineConf.priceAgreementConfirmType.OUR_CONFIRM
                ? `/api/${schema.name}/doOurAgreementConfirm`
                : `/api/${schema.name}/doPartnerAgreementConfirm`;

        apiClient
            .put(url, requestData)
            .then((response) => {
                if (response.data.fails.length === 0) {
                    refresh.refresh();
                    onSuccess(
                        t("success.agreementConfirmSuccess", {
                            table: schema.name,
                            confirmCount: response.data.successes.length.toString(),
                        })
                    );
                } else if (response.data.successes.length === 0) {
                    let reasons = makeReasonStr(response.data.reasons);
                    onFailure(t("error.agreementConfirmFailure", { reason: reasons }));
                } else {
                    let reasons = makeReasonStr(response.data.reasons);
                    refresh.refresh();
                    onPartialFailure(
                        t("warning.partialAgreementConfirmFailure", {
                            success: response.data.successes.length,
                            fail: response.data.fails.length,
                            reson: reasons,
                        })
                    );
                }
            })
            .catch((reason) => {
                console.error(reason);
                onFailure(
                    t("error.agreementConfirmFailure", { reason: reason.response ? reason.response.data : reason })
                );
            });
    };

    return (
        <>
            <ActionButtonLayout id={id + "-confirm-button"} variant="outlined" onClick={onOpen} {...others}>
                {confirmType === defineConf.priceAgreementConfirmType.OUR_CONFIRM
                    ? t("buttonName.ourAgreementConfirm")
                    : t("buttonName.partnerAgreementConfirm")}
            </ActionButtonLayout>
            <ConfirmDialog
                id={id + "-confirm-dialog"}
                title={
                    schema
                        ? confirmType === defineConf.priceAgreementConfirmType.OUR_CONFIRM
                            ? t(`dialog.title.${schema.name}.ourConfirm`)
                            : t(`dialog.title.${schema.name}.partnerConfirm`)
                        : ""
                }
                msg={confirmMsg}
                data={confirmData}
                open={open}
                onClose={onClose}
                onOk={onConfirmOk}
                onCancel={onClose}
            />
        </>
    );
}

export default TkPartnerPriceAgreementConfirmButton;
